module.exports = __webpack_public_path__ + "img/date_invalid.9ca374bc.svg";